import { render, staticRenderFns } from "./App.vue?vue&type=template&id=1788c8ed&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=1788c8ed&prod&scoped=true&lang=css&"
import style1 from "./App.vue?vue&type=style&index=1&id=1788c8ed&prod&lang=scss&"
import style2 from "./App.vue?vue&type=style&index=2&id=1788c8ed&prod&scss=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1788c8ed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VMain})
